<div class="hivemessage-overlay" *ngIf="visible">
  <div class="hivemessage-modal">

    <div class="modal-header">
      <div class="header-left">
        <div class="avatar" [ngClass]="avatarGender">
          <ng-container [ngSwitch]="avatarGender">
            
            <svg *ngSwitchCase="'female'" viewBox="0 0 24 24" width="40" height="40"><circle cx="12" cy="12" r="12" fill="#f43f5e" opacity="0.1"/><path fill="#f43f5e" d="M12,4c2.21,0,4,1.79,4,4s-1.79,4-4,4s-4-1.79-4-4S9.79,4,12,4z M12,14c4.42,0,8,1.79,8,4v2H4v-2C4,15.79,7.58,14,12,14z"/></svg>
            
            <svg *ngSwitchCase="'male'" viewBox="0 0 24 24" width="40" height="40"><circle cx="12" cy="12" r="12" fill="#3b82f6" opacity="0.1"/><path fill="#3b82f6" d="M12,4c2.21,0,4,1.79,4,4s-1.79,4-4,4s-4-1.79-4-4S9.79,4,12,4z M12,14c4.42,0,8,1.79,8,4v2H4v-2C4,15.79,7.58,14,12,14z"/></svg>
            
            <svg *ngSwitchDefault viewBox="0 0 24 24" width="40" height="40"><circle cx="12" cy="12" r="12" fill="#cbd5e1" opacity="0.3"/><path fill="#64748b" d="M12,12c2.21,0,4-1.79,4-4s-1.79-4-4-4s-4,1.79-4,4S9.79,12,12,12z M12,14c-2.67,0-8,1.34-8,4v2h16v-2C20,15.34,14.67,14,12,14z"/></svg>
          </ng-container>
        </div>

        <div class="contact-details">
          <h3>{{ contactName || phoneNumber }}</h3>
          <span class="meta-phone">
            <svg viewBox="0 0 24 24" width="12" height="12" style="margin-right: 3px; vertical-align: -1px;"><path fill="#25D366" d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/></svg>
            {{ phoneNumber }}
          </span>
        </div>
      </div>

      <div class="header-right">
        <div class="channel-select-wrapper" title="Switch Channel">
          <select [(ngModel)]="selectedChannel" (change)="onChannelChange()">
            <option [ngValue]="null">Select Channel</option>
            <option *ngFor="let channel of channels" [ngValue]="channel">{{ channel.name }}</option>
          </select>
          <svg class="chevron-down" viewBox="0 0 24 24" width="14" height="14"><path fill="#54656f" d="M12 15.5l-6-6h12l-6 6z"/></svg>
        </div>
        <button class="btn-close" (click)="closeModal()" title="Close">
          <svg viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
        </button>
      </div>
    </div>

    <div class="modal-body" #messagesContainer>

      <div *ngIf="loading" class="loading-state">
        <div class="loading-bounce"><span></span><span></span><span></span></div>
        <p>Loading messages...</p>
      </div>

      <div *ngIf="!loading && messages.length === 0" class="empty-state">
        <div class="empty-icon">
          <svg viewBox="0 0 303 172" width="200"><path fill="rgba(0,0,0,0.08)" d="M229.565 160.229c32.647-10.984 57.366-41.385 53.873-73.158-3.349-30.457-30.211-54.2-63.043-59.481-11.215-1.743-23.624-.398-33.98 4.97-7.563 3.921-13.854 10.09-21.676 13.426-14.369 6.134-30.804 1.782-45.811-2.058-22.436-5.74-46.544-8.204-67.925 1.09-31.563 13.71-46.466 54.876-29.282 84.787 11.337 19.725 33.267 31.645 56.576 36.498 23.309 4.853 47.491 3.112 71.226.504 21.795-2.393 45.166-1.718 62.482 6.355 3.66 1.705 7.458-.058 11.019-1.876 3.005-1.534 4.181-5.676 6.541-11.057z"/><rect fill="#42CBA5" x="107" y="70" width="86" height="53" rx="8"/><path fill="#fff" d="M134 92.8l-5.6-5.6-2.8 2.8 8.4 8.4 16.8-16.8-2.8-2.8z"/><circle fill="rgba(0,0,0,0.06)" cx="65" cy="106" r="40"/><circle fill="rgba(0,0,0,0.06)" cx="245" cy="96" r="30"/></svg>
        </div>
        <h4>No messages yet</h4>
        <p>Select a channel to start conversation</p>
      </div>

      <ng-container *ngFor="let msg of messages; let i = index">
        <div class="date-separator" *ngIf="shouldShowDateSeparator(i)">
          <span class="date-label">{{ getDateLabel(msg.timestamp) }}</span>
        </div>

        <div class="message-row" [ngClass]="msg.direction">
          <div class="message-bubble" [class.has-media]="msg.media_url">
            
            <svg *ngIf="msg.direction === 'inbound' && isFirstInGroup(i)" class="bubble-tail tail-in" viewBox="0 0 8 13" width="8" height="13"><path fill="#fff" d="M5 0l3 13H0z"/></svg>
            <svg *ngIf="msg.direction === 'outbound' && isFirstInGroup(i)" class="bubble-tail tail-out" viewBox="0 0 8 13" width="8" height="13"><path fill="#d9fdd3" d="M3 0L0 13h8z"/></svg>

            <div *ngIf="msg.reply_to_message_id" class="quoted-msg">
              <span class="quoted-title">Replied Message</span>
              <span class="quoted-text">ID: {{ msg.reply_to_message_id }}</span>
            </div>

            <div *ngIf="msg.media_url" class="media-content">
              <img *ngIf="msg.message_type === 'image'" [src]="msg.media_url" loading="lazy" />
              <video *ngIf="msg.message_type === 'video'" [src]="msg.media_url" controls preload="metadata"></video>
              <div *ngIf="msg.message_type === 'document'" class="doc-file">
                <div class="doc-icon"><svg viewBox="0 0 24 24" width="30" height="30"><path fill="#8696a0" d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/></svg></div>
                <div class="doc-info"><span class="doc-name">Document</span><span class="doc-size">File attachment</span></div>
              </div>
            </div>

            <div class="message-text" *ngIf="msg.message">{{ msg.message }}</div>

            <div class="message-meta">
              <span class="time">{{ msg.timestamp | date: 'shortTime' }}</span>
              <span *ngIf="msg.direction === 'outbound'" class="status-icon">
                <svg *ngIf="msg.status === 'sent' || msg.status === 'pending'" viewBox="0 0 16 15" width="16" height="11"><path fill="#8696a0" d="M15.01 3.316l-2.38-2.38A1.54 1.54 0 0 0 11.52.936L5.7 6.745l-2.38-2.38a1.54 1.54 0 0 0-2.18 2.18l3.5 3.5a1.54 1.54 0 0 0 2.19 0l6.9-6.9a1.534 1.534 0 0 0 .28-1.75z"></path></svg>
                <svg *ngIf="msg.status === 'delivered'" viewBox="0 0 16 15" width="16" height="11"><path fill="#8696a0" d="M15.01 3.316l-2.38-2.38A1.54 1.54 0 0 0 11.52.936L5.7 6.745l-2.38-2.38a1.54 1.54 0 0 0-2.18 2.18l3.5 3.5a1.54 1.54 0 0 0 2.19 0l6.9-6.9a1.534 1.534 0 0 0 .28-1.75z"></path><path fill="#8696a0" d="M6 6.745l-2.38-2.38a1.54 1.54 0 0 0-2.18 2.18l3.5 3.5a1.54 1.54 0 0 0 2.19 0l6.9-6.9a1.534 1.534 0 0 0 .28-1.75z" style="transform: translateX(-5px);"></path></svg>
                <svg *ngIf="msg.status === 'read'" viewBox="0 0 16 15" width="16" height="11"><path fill="#53bdeb" d="M15.01 3.316l-2.38-2.38A1.54 1.54 0 0 0 11.52.936L5.7 6.745l-2.38-2.38a1.54 1.54 0 0 0-2.18 2.18l3.5 3.5a1.54 1.54 0 0 0 2.19 0l6.9-6.9a1.534 1.534 0 0 0 .28-1.75z"></path><path fill="#53bdeb" d="M6 6.745l-2.38-2.38a1.54 1.54 0 0 0-2.18 2.18l3.5 3.5a1.54 1.54 0 0 0 2.19 0l6.9-6.9a1.534 1.534 0 0 0 .28-1.75z" style="transform: translateX(-5px);"></path></svg>
                <span *ngIf="msg.status === 'failed'" class="status-failed">!</span>
              </span>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="modal-footer" [class.locked-state]="!selectedChannel">

      <div class="template-popup-container" *ngIf="showTemplatePopup">
        <div class="popup-header">
          <svg viewBox="0 0 24 24" width="16" height="16" style="margin-right: 6px"><path fill="#fff" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM12 10.5L8.5 14h7L12 10.5z"/></svg> Select Template
        </div>
        <div class="popup-search" *ngIf="templates.length > 5">
          <input type="text" placeholder="Search templates..." class="template-search-input" />
        </div>
        <div class="popup-list">
          <div *ngFor="let tmpl of templates" class="popup-item" (click)="selectTemplate(tmpl)">
            <div class="tmpl-name">{{ tmpl.name }}</div>
            <div class="tmpl-preview" *ngIf="tmpl.content">{{ tmpl.content | slice:0:60 }}{{ tmpl.content.length > 60 ? '...' : '' }}</div>
          </div>
          <div *ngIf="templates.length === 0" class="popup-empty">No templates available</div>
        </div>
      </div>

      <div class="mini-warning-toast" *ngIf="showInfoToast && !isWithin24HourWindow">
        <svg viewBox="0 0 24 24" width="14" height="14" style="flex-shrink:0"><path fill="#856404" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>
        <span>If client is not reply to your message within 24 hours,direct message will not be sent .</span>
      </div>

      <div class="success-toast" [class.visible]="showSuccessToast">
        <svg viewBox="0 0 24 24" width="18" height="18" style="flex-shrink:0"><path fill="#fff" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
        Message sent successfully
      </div>

      <div class="attachment-preview" *ngIf="attachmentUrl">
        <div class="preview-content">
          <svg viewBox="0 0 24 24" width="20" height="20"><path fill="#00a884" d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/></svg>
          <span class="preview-name">{{ attachmentFilename || 'File attached' }}</span>
        </div>
        <button class="preview-remove" (click)="clearAttachment()" title="Remove">
          <svg viewBox="0 0 24 24" width="16" height="16"><path fill="#8696a0" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
        </button>
      </div>

      <div class="input-area">
        <div class="actions-left">
          <button class="action-btn" [class.disabled]="!selectedChannel" [disabled]="!selectedChannel" (click)="selectedChannel && toggleTemplatePopup()" title="Templates" [class.active]="showTemplatePopup">
            <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="3" y1="9" x2="21" y2="9"></line><line x1="9" y1="21" x2="9" y2="9"></line></svg>
          </button>
          
          <input type="file" #fileInput (change)="onFileSelected($event)" style="display: none">
          <button *ngIf="!isTemplateLocked" class="action-btn" [class.disabled]="!selectedChannel" [disabled]="!selectedChannel" (click)="selectedChannel && fileInput.click()" title="Attach File">
            <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path></svg>
          </button>
        </div>

        <div class="input-wrapper" [class.locked]="isTemplateLocked || !selectedChannel">
          <textarea
            [(ngModel)]="newMessage"
            (input)="onUserTyping()"
            (keydown.enter)="onEnterKey($event)"
            [disabled]="!selectedChannel || isTemplateLocked"
            rows="1"
            placeholder="{{ !selectedChannel ? 'Select channel first' : 'Type a message' }}">
          </textarea>
          <button *ngIf="isTemplateLocked" class="clear-tmpl" (click)="clearTemplate()" title="Clear Template">
            <svg viewBox="0 0 24 24" width="18" height="18"><path fill="#8696a0" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
          </button>
        </div>

        <button class="send-btn" (click)="sendMessage()" [disabled]="(!newMessage && !attachmentUrl) || !selectedChannel || sending" [class.ready]="(newMessage || attachmentUrl) && selectedChannel && !sending">
          <div class="spinner" *ngIf="sending"></div>
          <svg *ngIf="!sending" viewBox="0 0 24 24" width="24" height="24"><path fill="#fff" d="M1.101 21.757L23.8 12.028 1.101 2.3l.011 7.912 13.623 1.816-13.623 1.817-.011 7.912z"></path></svg>
        </button>
      </div>
    </div>

  </div>
</div>